import { render, staticRenderFns } from "./OtherFileHarvester.vue?vue&type=template&id=a90c230a&"
import script from "./OtherFileHarvester.vue?vue&type=script&lang=ts&"
export * from "./OtherFileHarvester.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports